import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Button } from "@revvsales/components";
import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class CheckboxField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxFieldValues: this._getDataForPrepopulate(props),
    };
  }

  componentDidMount() {
    this.props.setFlagForDefault(true);
  }

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.CHECKBOX),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = {
        options: propsData.meta.options,
        default: this._getPreselectedDefaultItem(propsData.meta),
      };
    }
    return returnData;
  };

  _getPreselectedDefaultItem = data => {
    const returnData = [];
    if (data.options && data.options.length > 0) {
      for (let x = 0; x < data.options.length; x += 1) {
        returnData.push(undefined);
        if (data.default && data.default.length > 0) {
          for (let y = 0; y < data.default.length; y += 1) {
            if (data.options[x] === data.default[y]) {
              returnData[x] = true;
            }
          }
        }
      }
    }
    return returnData;
  };

  getDefualtValue = data => {
    const defaultData = [];
    if (data.default.length > 0) {
      for (let v = 0; v < data.default.length; v += 1) {
        if (data.default[v] === true) {
          defaultData.push(data.options[v]);
        }
      }
    }
    return defaultData;
  };

  getDefualtOptions = data => {
    const optionsData = [];
    if (data.options.length > 0) {
      for (let v = 0; v < data.options.length; v += 1) {
        if (data.options[v] !== "") {
          optionsData.push(data.options[v]);
        }
      }
    }
    return optionsData;
  };

  buttonValidation = options => {
    const duplicate = this.showDupPos(options);
    if (duplicate.length > 0) {
      this.props.metaValidStatus(false);
      return;
    }
    let check = false;
    options.forEach(d => {
      if (d === "") {
        check = true;
        this.props.metaValidStatus(false);
      } else if (d !== "" && check === false) {
        this.props.metaValidStatus(true);
        this.props.setFlagForDefault(true);
      }
    });
  };

  showDupPos = arr => {
    let result = [];
    const positions = {};
    // collect all positions
    arr.forEach((value, pos) => {
      positions[value] = positions[value] || [];
      positions[value].push(pos);
    });
    // check how much of same value in string
    Object.keys(positions).forEach(value => {
      const posArray = positions[value];
      if (posArray.length > 1) {
        result = result.concat(posArray);
      }
    });
    return result.sort();
  };

  render() {
    const { checkboxFieldValues } = this.state;
    console.debug("CheckboxField", checkboxFieldValues);
    return (
      <React.Fragment>
        {
          <RevvForm
            initialFormValue={checkboxFieldValues}
            customFieldName="CHECKBOX"
            validateOnChange
            customFieldComponentRules={CustomFieldComponentRules}
            customFieldComponentMessages={CustomFieldComponentMessages}
            render={formProps => {
              const {
                handleChangeInList,
                handleAddToList,
                handleRemoveFromList,
                messages,
                touched,
                errors,
                values,
                isValid,
              } = formProps;
              const allInAll = {
                isValid,
                messages,
                touched,
                errors,
                values,
              };
              this.buttonValidation(values.options);
              const dataCommunication = {
                default: this.getDefualtValue(values),
                options: this.getDefualtOptions(values),
              };

              this.props.setMetaFieldValues(dataCommunication);
              console.debug("allInAllCheckbox", allInAll, dataCommunication);

              this.updateOptions = () => {
                handleAddToList("options", "");
                handleAddToList("default", false);
              };

              this.removeField = index => {
                handleRemoveFromList("options", index);
                handleRemoveFromList("default", index);
              };

              return values.options.map((data, i) => (
                <React.Fragment>
                  <div
                    className="revv-form-items"
                    data-test="checkboxfield-revv-form-items">
                    <div
                      className="custom-feild-formitem"
                      data-test="checkboxfield-custom-feild-formitem">
                      <div
                        className="revvform-label"
                        data-test="checkboxfield-revvform-label">
                        Value({i + 1})
                        <span
                          className="requiredwitherr-input"
                          data-test="checkboxfield-requiredwitherr-input">
                          *
                        </span>
                      </div>

                      <div
                        className="checkboxpos"
                        data-test="checkboxfield-checkboxpos">
                        <div data-test="checkboxfield-checkboxdefaultbox-wrapper">
                          <Input
                            name="default"
                            data-test="checkboxfield-checkbox-input"
                            type="checkbox"
                            checked={values.default[i]}
                            className="dynamicfieldcustom-footer-input errorborder marright"
                            onChange={event => handleChangeInList(event, i)}
                          />
                          <span
                            className="revvform-label"
                            data-test="checkboxfield-defaultvale-text">
                            This is default value
                          </span>
                        </div>

                        {values.options.length > 1 && (
                          <div
                            className="customselect-delete-option"
                            data-test="checkboxfield-customselect-delete-option">
                            <span
                              className="btn-icon"
                              data-test="checkboxfield-deletebtn-icon"
                              onClick={() => this.removeField(i)}
                              onKeyPress={() => this.removeField(i)}
                              role="button"
                              tabIndex="0">
                              <FontAwesomeIcon icon={["far", "trash-alt"]} />
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <Input
                      name="options"
                      data-test="checkboxfield-options-input"
                      type="text"
                      value={values.options[i]}
                      placeholder="Enter field value"
                      className="dynamicfieldcustom-footer-input errorborder"
                      onChange={event => handleChangeInList(event, i)}
                    />
                  </div>
                  {/* <JSONPretty id="json-pretty" data={allInAll} /> */}
                  {values.options.length - 1 === i && (
                    <div
                      className="clause-options-add-option"
                      data-test="checkboxfield-addoption-button-wrapper">
                      <Button
                        className="revv-btn-secondary-sm"
                        data-test="checkboxfield-addoption-button"
                        onClick={() => this.updateOptions()}
                        onKeyPress={() => this.updateOptions()}
                        role="button"
                        tabIndex="0">
                        <i>
                          <FontAwesomeIcon
                            icon={["far", "plus-circle"]}
                            className=""
                          />
                        </i>
                        Add another rule
                      </Button>
                    </div>
                  )}
                </React.Fragment>
              ));
            }}
          />
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
  setFlagForCommonFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CheckboxField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/CheckboxField.js